export default __webpack_public_path__ + "static/media/Prologue_Haven1.06805559.png";